import { useCallback, useEffect, useState } from "react";
import { http, toastApiError } from "../../lib/api";
import { toast } from "../../lib/notify";
import { useAuth } from "../../context/AuthContext";
import OfferSlot from "./OfferSlot";

export const OFFER_SLOTS = ["BİRİNCİ TEKLİF", "İKİNCİ TEKLİF", "ÜÇÜNCÜ TEKLİF", "DÖRDÜNCÜ TEKLİF"];
const isXlsx = (f) => /\.(xlsx|xlsm)$/i.test(f?.name || "");

// Excel'deki 4 teklif kutusu (A33:G41): her kutuya teklif Excel'i yüklenir (byte-byte saklanır → indirince formüller aynen durur), önceki sürümler saklanır
export default function OfferSlots({ prospect, canEdit }) {
  const { user } = useAuth();
  const [data, setData] = useState({ slots: {}, history: [] });
  const [busy, setBusy] = useState(0);
  const load = useCallback(() => http.get(`/prospects/${prospect.id}/offers`).then((r) => setData(r.data)).catch(() => setData({ slots: {}, history: [] })), [prospect.id]);
  useEffect(() => { load(); }, [load]);
  const upload = async (slot, file) => {
    if (!file) return;
    if (!isXlsx(file)) return toast.error("Yalnız Excel (.xlsx / .xlsm) dosyası yüklenebilir");
    setBusy(slot);
    try {
      const fd = new FormData(); fd.append("file", file);
      await http.post(`/prospects/${prospect.id}/offers/${slot}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`${OFFER_SLOTS[slot - 1]} yüklendi — dosya olduğu gibi saklandı`); await load();
    } catch (e) { toastApiError(e); } finally { setBusy(0); }
  };
  const remove = async (d) => {
    if (!window.confirm(`"${d.filename}" silinsin mi?${d.is_current ? " (Varsa bir önceki sürüm geçerli olur.)" : ""}`)) return;
    try { await http.delete(`/prospect-offers/${d.id}`); toast.success("Teklif dosyası silindi"); load(); } catch (e) { toastApiError(e); }
  };
  const canDelete = (d) => user?.role === "admin" || d.created_by === user?.email;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 border-t border-l border-slate-400" data-testid="prospect-offers">
      {OFFER_SLOTS.map((label, i) => (
        <OfferSlot key={i + 1} slot={i + 1} label={label} cur={data.slots[String(i + 1)] || null} history={data.history.filter((h) => h.slot === i + 1)} canEdit={canEdit} canDelete={canDelete} busy={busy === i + 1} onUpload={(f) => upload(i + 1, f)} onDelete={remove} />
      ))}
    </div>
  );
}
